import {
  formEditorUrl,
  formPublicYandexUrl,
  getFormSource,
} from "@/lib/forms/formSource";
import type { FormDto } from "@/types/form";
import type { FormBuilderMeta } from "./types";

export function formMetaFromForm(form: FormDto): FormBuilderMeta {
  return {
    source: getFormSource(form),
    publicId: form.publicId?.trim() || null,
    editorUrl: formEditorUrl(form),
    publicUrl: formPublicYandexUrl(form),
    organisationId: form.organisationId ?? null,
    externalServiceId: form.externalServiceId ?? null,
    externalServiceName: form.externalService?.name?.trim() || null,
    yandexSurveyId: form.yandexSurveyId ?? null,
    createdAt: form.createdAt ?? form.created_at ?? null,
    updatedAt: form.updatedAt ?? form.updated_at ?? null,
  };
}
